import { render, staticRenderFns } from "./ReservationColumnGroupNew.vue?vue&type=template&id=65ae483d&scoped=true&"
import script from "./ReservationColumnGroupNew.vue?vue&type=script&lang=js&"
export * from "./ReservationColumnGroupNew.vue?vue&type=script&lang=js&"
import style0 from "./ReservationColumnGroupNew.vue?vue&type=style&index=0&id=65ae483d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65ae483d",
  null
  
)

export default component.exports